export class CodePay {
	code: string;
	description: string;
	idreqRef: boolean;
	label: string;

	constructor() {
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/payment-federal-taxes/models/code-pay.ts